import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import { IconButton, Tooltip } from "@mui/material";
import { toast } from "react-toastify";
import DownloadIcon from "@mui/icons-material/Download";
import { Helmet } from "react-helmet";
import Axios from "../axios";
import { CSVLink } from "react-csv";
import { useLocation } from "react-router-dom";
import moment from "moment";
import Switch from "@mui/material/Switch";
import { useAuth } from "../auth/authContext";
const ExploreTripListing = () => {
  const { navData } = useAuth();
  const location = useLocation();
  const [allTrip, setAllTrip] = useState();
  const [page, setPage] = useState(0);
  const [count, setCount] = useState();
  const [search, setSearch] = useState("");
  const { passedValue } = location?.state || {};
  const [write, setWrite] = useState(false);
  //data for the CSV file
  const [downloadData, setDownloadData] = useState([]);
  //header for the CSv file
  const headers = [
    { label: "Trip Name", key: "tripName" },
    { label: "User Name", key: "userName" },
    { label: "Created Date", key: "createdAt" },
    { label: "Explore Status", key: "exploreuserStatus" },
  ];

  useEffect(() => {
    if (passedValue) {
      fetchAllTrip(0, "", passedValue); // Use `passedValue` if it exists
    } else {
      fetchAllTrip(0, "", ""); // Default behavior
    }
    handleDownloadProcess();
  }, [passedValue]);
  useEffect(() => {
    const currentPath = location.pathname;
    const matchingNavItem = navData.find((item) => item.link === currentPath);
    if (matchingNavItem) {
      setWrite(matchingNavItem.write);
    } else {
      setWrite(false);
    }
  }, [location.pathname, navData]);

  const fetchAllTrip = (page, search, id) => {
    let data = {
      page: page,
      searchChar: search,
      userID: id,
    };
    Axios.post(process.env.REACT_APP_BACKEND + "get-explore-trips", data)
      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  const handleDownloadProcess = () => {
    Axios.post(process.env.REACT_APP_BACKEND + "get-explore-trip-csv-data")
      .then((resp) => {
        setDownloadData(resp?.data?.data);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  //-------------option for the mui table----------------------------
  const options = {
    responsive: "standard",
    selectableRows: "none",
    filter: false,
    viewColumns: false,
    serverSide: true,
    rowsPerPageOptions: [],
    count: count,
    download: false,
    page,
    onTableChange: (action, tableState) => {
      if (action === "changePage") {
        fetchAllTrip(tableState.page, search);
        setPage(tableState.page);
      }
    },
    onSearchChange: (searchText) => {
      fetchAllTrip(page, searchText);
      setSearch(searchText);
    },
    customToolbar: () => (
      <>
        <Tooltip title="Download">
          <IconButton>
            <CSVLink
              data={downloadData}
              headers={headers}
              filename={"exploreTrip.csv"}
            >
              <DownloadIcon />
            </CSVLink>
          </IconButton>
        </Tooltip>
      </>
    ),
  };

  const columns = [
    {
      name: "Action",
      label: "Trip Image",

      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <img
                src={allTrip[dataIndex]?.locationImg}
                style={{ width: "60px" }}
              />
            </>
          );
        },
      },
    },
    {
      name: "tripName",
      label: "Trip Name",
      options: {
        filter: true,
        sort: false,
      },
    },
    {
      name: "username",
      label: "User Name",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return <div>{allTrip[dataIndex]?.userId?.name}</div>;
        },
      },
    },
    {
      name: "role",
      label: "Created Date",
      options: {
        filter: true,
        sort: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <div>
              {moment(allTrip[dataIndex].createdAt).format("YYYY-MM-DD")}
            </div>
          );
        },
      },
    },

    write && {
      name: "options",
      label: "Action",
      options: {
        filter: false,
        sort: false,

        customBodyRenderLite: (dataIndex) => {
          return (
            <>
              <Switch
                checked={allTrip[dataIndex]?.explore}
                onChange={(event) =>
                  handleChange(event, allTrip[dataIndex]?._id)
                }
                inputProps={{ "aria-label": "controlled" }}
              />
            </>
          );
        },
      },
    },
  ].filter(Boolean);

  const handleChange = (event, tripId) => {
    handleStatus(tripId); // Pass the checked state and tripId
  };
  const handleStatus = (id) => {
    let data = {
      id: id,
      userID: passedValue ? passedValue : "",
    };
    Axios.post(process.env.REACT_APP_BACKEND + "remove-explore-trip", data)

      .then((resp) => {
        setAllTrip(resp?.data?.data?.docs);
        setCount(resp?.data?.data?.totalDocs);
        toast.success(resp && resp.data && resp.data.message);
      })
      .catch((err) => {
        toast.error(
          err && err.response && err.response.data && err.response.data.message
        );
      });
  };
  return (
    <>
      <Helmet>
        <title>Sevenly-Explore Trip</title>
        <meta name="Explore Trip" content="Explore Trip for Home Page" />
      </Helmet>
      <MUIDataTable
        title={"Explore Trip List"}
        data={allTrip}
        columns={columns}
        options={options}
      />
    </>
  );
};
export default ExploreTripListing;
